module.exports = __webpack_public_path__ + "img/red_073.0b7b0575.png";